<template>
  <div class="comm_popup_wrap_large">
    <div class="comm_view_wrap">
      <div class="row">
        <div class="col-xs-2">
          <sui-input-label
            :label="$t('MSG_TXT_MDLE')"
            :required="false"
            :vertical="false"
          />
        </div>
        <div class="col-xs-4">
          <sui-module-submodule-select
            ref="moduleCode"
            :pageId="pageId"
            :selectedMd="selectedCodeValue.moduleCode"
            :selectedSmd="selectedCodeValue.subModuleCode"
            class="dp_flex"
          />
        </div>
        <div class="col-xs-2">
          <sui-input-label
            :label="$t('MSG_TXT_IF_ID')"
            :required="false"
            :vertical="false"
          />
        </div>
        <div class="col-xs-4">
          <div class="comm_label">
            {{ interfaceData.interfaceId }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-2">
          <sui-input-label
            :label="$t('MSG_TXT_IF_NM')"
            :required="false"
            :vertical="false"
          />
        </div>
        <div class="col-xs-4">
          <sui-text-field
            ref="interfaceName"
            v-model.trim="interfaceData.interfaceName"
            maxlength="25"
          />
        </div>
        <div class="col-xs-2">
          <sui-input-label
            :label="$t('MSG_TXT_TRMT_TYPE')"
            :required="false"
            :vertical="false"
          />
        </div>
        <div class="col-xs-4">
          <sui-code-select
            ref="interfaceTransmitTypeCode"
            :selected="selectedCodeValue.interfaceTransmitTypeCode"
            :pageId="pageId"
            codeId="COD_IF_TRMT_TYPE"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-xs-2">
          <sui-input-label
            :label="$t('MSG_TXT_CONN_SYS_NM')"
            :required="false"
            :vertical="false"
          />
        </div>
        <div class="col-xs-4">
          <sui-text-field
            v-model.trim="interfaceData.interfaceConnectionSystemName"
            maxlength="25"
          />
        </div>
        <div class="col-xs-2">
          <sui-input-label
            :label="$t('MSG_TXT_CONN_ID')"
            :required="false"
            :vertical="false"
          />
        </div>
        <div class="col-xs-4">
          <sui-text-field
            v-model.trim="interfaceData.interfaceConnectionId"
            maxlength="100"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-xs-2">
          <sui-input-label
            :label="$t('MSG_TXT_SEND_SYS_NM')"
            :required="false"
            :vertical="false"
          />
        </div>
        <div class="col-xs-4">
          <sui-text-field
            v-model.trim="interfaceData.interfaceSendSystemName"
            maxlength="25"
          />
        </div>
        <div class="col-xs-2">
          <sui-input-label
            :label="$t('MSG_TXT_RECP_SYS_NM')"
            :required="false"
            :vertical="false"
          />
        </div>
        <div class="col-xs-4">
          <sui-text-field
            v-model.trim="interfaceData.interfaceReceiptSystemName"
            maxlength="25"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-xs-2">
          <sui-input-label
            :label="$t('MSG_TXT_PRG_NM')"
            :required="false"
            :vertical="false"
          />
        </div>
        <div class="col-xs-4">
          <cmp-program-select
            v-model="interfaceData.interfaceProgramName"
            :selectedPrg="selectedPrg"
            :readonly="true"
            @selected="onSelectedPrg"
          />
        </div>
        <div class="col-xs-2">
          <sui-input-label
            :label="$t('MSG_TXT_PROC_TYPE')"
            :required="false"
            :vertical="false"
          />
        </div>
        <div class="col-xs-4">
          <sui-code-select
            ref="interfaceProcessTypeCode"
            :selected="selectedCodeValue.interfaceProcessTypeCode"
            :pageId="pageId"
            codeId="COD_IF_PROC_TYPE"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-xs-2">
          <sui-input-label
            :label="$t('MSG_TXT_CONN_WAY')"
            :required="false"
            :vertical="false"
          />
        </div>
        <div class="col-xs-4">
          <sui-code-select
            ref="interfaceWayName"
            :selected="selectedCodeValue.interfaceWayName"
            :pageId="pageId"
            codeId="COD_IF_CONN_TYPE"
            :initialSelectedIndex="0"
          />
        </div>
        <div class="col-xs-2">
          <sui-input-label
            :label="$t('MSG_TXT_DIV')"
            :required="false"
            :vertical="false"
          />
        </div>
        <div class="col-xs-4">
          <sui-code-select
            ref="interfaceDivisionCode"
            :selected="selectedCodeValue.interfaceDivisionCode"
            :pageId="pageId"
            codeId="COD_IF_DIV"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-xs-2">
          <sui-input-label
            :label="$t('MSG_TXT_CMNC_TYPE')"
            :required="false"
            :vertical="false"
          />
        </div>
        <div class="col-xs-4">
          <sui-code-select
            ref="interfaceCommunicationTypeCode"
            :selected="selectedCodeValue.interfaceCommunicationTypeCode"
            :pageId="pageId"
            codeId="COD_IF_CMNC_TYPE"
          />
        </div>
        <div class="col-xs-2">
          <sui-input-label
            :label="$t('MSG_TXT_DATA_FMT')"
            :required="false"
            :vertical="false"
          />
        </div>
        <div class="col-xs-4">
          <sui-code-select
            ref="interfaceDataFormatCode"
            :selected="selectedCodeValue.interfaceDataFormatCode"
            :pageId="pageId"
            codeId="COD_IF_DATA_FMT"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-xs-2">
          <sui-input-label
            :label="$t('MSG_TXT_CYCL')"
            :required="false"
            :vertical="false"
          />
        </div>
        <div class="col-xs-4">
          <sui-text-field
            v-model.trim="interfaceData.interfaceCycleContent"
            maxlength="100"
            class="width100"
          />
        </div>
        <div class="col-xs-2">
          <sui-input-label
            :label="$t('MSG_TXT_HIS_MGT_YN')"
            :required="false"
            :vertical="false"
          />
        </div>
        <div class="col-xs-4">
          <sui-radio
            v-model="interfaceData.interfaceHistoryManagementYn"
            value="Y"
          >
            Yes
          </sui-radio>
          <sui-radio
            v-model="interfaceData.interfaceHistoryManagementYn"
            value="N"
          >
            No
          </sui-radio>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-2">
          <sui-input-label
            :label="$t('MSG_TXT_CNTN')"
            :required="false"
            :vertical="false"
          />
        </div>
        <div class="col-xs-10">
          <textarea
            v-model.trim="interfaceData.interfaceContent"
            rows="5"
            maxlength="1000"
            class="width100"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-xs-2">
          <sui-input-label
            :label="$t('MSG_TXT_RGST_USR')"
            :vertical="false"
          />
        </div>
        <div class="col-xs-4">
          <cmp-user-name-link
            :pageId="pageId"
            :displayType="'1'"
            :displayLanguageId="interfaceData.r_dsplLngId"
            :knoxId="interfaceData.r_knoxId"
            :userName="interfaceData.r_userName"
            :userGlobalName="interfaceData.r_userGlobalName"
            :departmentName="interfaceData.r_departmentName"
            :departmentEnglishName="interfaceData.r_departmentEnglishName"
            type="link"
          />
        </div>
        <div class="col-xs-2">
          <sui-input-label
            :label="$t('MSG_TXT_RGST_DTM')"
            :vertical="false"
          />
        </div>
        <div class="col-xs-4">
          <div class="comm_label">
            {{ interfaceData.firstRegistrationDTM }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-2">
          <sui-input-label
            :label="$t('MSG_TXT_MDFC_USR')"
            :vertical="false"
          />
        </div>
        <div class="col-xs-4">
          <cmp-user-name-link
            :pageId="pageId"
            :displayType="'1'"
            :displayLanguageId="interfaceData.m_dsplLngId"
            :knoxId="interfaceData.m_knoxId"
            :userName="interfaceData.m_userName"
            :userGlobalName="interfaceData.m_userGlobalName"
            :departmentName="interfaceData.m_departmentName"
            :departmentEnglishName="interfaceData.m_departmentEnglishName"
            type="link"
          />
        </div>
        <div class="col-xs-2">
          <sui-input-label
            :label="$t('MSG_TXT_MDFC_DTM')"
            :vertical="false"
          />
        </div>
        <div class="col-xs-4">
          <div class="comm_label">
            {{ interfaceData.finalModificationDTM }}
          </div>
        </div>
      </div>
    </div>
    <div class="comm_btnBot_wrap">
      <div class="btn_wrapL">
        <sui-button
          v-permission:read="pageId"
          type="button"
          class="comm_btn_border"
          @click="onHistoryListClick"
        >
          {{ $t("MSG_BTN_HIS_SRCH") }}
        </sui-button>
      </div>
      <div class="btn_wrapR">
        <sui-button
          v-permission:read="pageId"
          type="button"
          class="comm_btn_border"
          @click="onModAndCancelClick"
        >
          {{ $t('MSG_BTN_CANCEL') }}
        </sui-button>
        <sui-button
          v-permission:delete="pageId"
          type="button"
          class="comm_btn_border"
          @click="onDeleteClick"
        >
          {{ $t("MSG_BTN_DEL") }}
        </sui-button>
        <sui-button
          v-permission:update="pageId"
          type="button"
          class="comm_btn_solid"
          @click="onSaveClick"
        >
          {{ $t('MSG_BTN_SAVE') }}
        </sui-button>
      </div>
    </div>
  </div>
</template>
<script>
// import - libraries (node modules)
// import - local files (js, vue, ...)
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CMS_00002_P02', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    pageId: {
      type: String,
      default: '',
    },
    interfaceId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      processYn: [{
        label: this.$t('MSG_TXT_SUC'),
        key: 'Y',
      }, {
        label: this.$t('MSG_TXT_FAIL'),
        key: 'N',
      }],
      searchFrame: {
        COD_IF_PROC_YN: {
          lavel: '',
          key: '',
        },
        rangeDate: {
          from: '',
          to: '',
        },
      },
      selectedCodeValue: {
        moduleCode: {
          label: '',
          key: '',
        },
        subModuleCode: {
          label: '',
          key: '',
        },
        interfaceTransmitTypeCode: {
          label: '',
          key: '',
        },
        interfaceProcessTypeCode: {
          label: '',
          key: '',
        },
        interfaceWayName: {
          label: '',
          key: '',
        },
        interfaceDivisionCode: {
          label: '',
          key: '',
        },
        interfaceCommunicationTypeCode: {
          label: '',
          key: '',
        },
        interfaceDataFormatCode: {
          label: '',
          key: '',
        },
      },
      selectedPrg: {
        programName: '',
        programId: '',
      },
      programFlag: false,
      interfaceData: {},
    };
  },
  watch: {
    // data 변경시 특정 함수를 호출 해야 하는 경우(async 등)
  },
  mounted() {
    this.$nextTick(() => {
      if (!utils.isEmpty(this.interfaceId)) {
        this.interfaceDataLoad(this.interfaceId);
      }
    });
  },
  beforeUpdate() {
    // data 변경전 DOM 정보가 필요한 경우
  },
  updated() {
    // data 변경후 DOM 정보가 필요한 경우
  },
  beforeDestroy() {
    // 이벤트 핸들러 및 사용한 서드 파티 라이브러리 자원 반환
  },
  destroyed() {
    // 남아 있는 자원 반환
  },
  methods: {
    interfaceDataLoad(id) {
      http.request(this.pageId, 'DTS_CMS_00002', {
        path: {
          'interface-id': id,
        },
      }).then(res => {
        res.data.firstRegistrationDTM = utils.dateformatToClient(res.data.firstRegistrationDTM);
        res.data.finalModificationDTM = utils.dateformatToClient(res.data.finalModificationDTM);
        this.interfaceData = this.setUserInfoFormat(res.data);
        this.selectedPrg.programName = this.interfaceData.interfaceProgramName;
        this.setSelectBox(this.interfaceData);
      }).catch(error => {
        console.log(error);
      });
    },
    setUserInfoFormat(data) {
      utils.forEach(data.firstRegistrationUserInfo, (value, key) => {
        utils.set(data, `r_${key}`, value);
      });
      utils.forEach(data.finalModificationUserInfo, (value, key) => {
        utils.set(data, `m_${key}`, value);
      });
      return data;
    },
    setSelectBox(data) {
      utils.forEach(this.$refs, (ref, key) => {
        if (utils.startsWith(key, 'interface') && !utils.isEqual(key, 'interfaceName')) {
          ref.select(data[key]);
        } else if (utils.isEqual(key, 'moduleCode')) {
          ref.selectMd(data.moduleCode);
          ref.selectSmd(data.subModuleCode);
        }
      });
    },
    onModAndCancelClick() {
      this.$emit('onModAndCancelClick');
    },
    onSelectedPrg() {
      this.programFlag = true;
      this.interfaceData.interfaceProgramId = this.selectedPrg.programId;
    },
    getSelectedCodeValue() {
      const data = {};
      utils.forEach(this.selectedCodeValue, (value, key) => {
        data[key] = value.key;
      });
      return data;
    },
    onSaveClick() {
      const saveData = utils.assign(this.interfaceData, this.getSelectedCodeValue());
      const result = this.validation(saveData);
      if (result.valid) {
        this.saveAction(saveData);
      } else {
        utils.messageBox('warning', result.message, null, () => {
          this.$refs[result.focus].setFocus();
        });
      }
    },
    validation(data) {
      const result = {
        valid: true,
        message: '',
        focus: '',
      };
      utils.forEach(data, (value, key) => {
        if (utils.isEmpty(value)) {
          result.valid = false;
          switch (key) {
            case 'moduleCode':
              result.message = utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_MDLE'));
              return false;
            case 'subModuleCode':
              result.message = utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_SMDLE'));
              return false;
            // case 'interfaceId':
            //   result.message = utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_IF_ID'));
            //   return false;
            case 'interfaceName':
              result.message = utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_IF_NM'));
              result.focus = key;
              return false;
            // case 'interfaceTransmitTypeCode':
            //   result.message = utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_TRMT_TYPE'));
            //   return false;
            // case 'interfaceConnectionSystemName':
            //   result.message = utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_CONN_SYS_NM'));
            //   return false;
            // case 'interfaceConnectionId':
            //   result.message = utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_CONN_ID'));
            //   return false;
            // case 'interfaceSendSystemName':
            //   result.message = utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_SEND_SYS_NM'));
            //   return false;
            // case 'interfaceReceiptSystemName':
            //   result.message = utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_RECP_SYS_NM'));
            //   return false;
            // case 'interfaceProgramId':
            //   result.message = utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_PRG_ID'));
            //   return false;
            // case 'interfaceProcessTypeCode':
            //   result.message = utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_PROC_TYPE'));
            //   return false;
            // case 'interfaceWayName':
            //   result.message = utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_CONN_WAY'));
            //   return false;
            // case 'interfaceDivisionCode':
            //   result.message = utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_DIV'));
            //   return false;
            // case 'interfaceCommunicationTypeCode':
            //   result.message = utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_CMNC_TYPE'));
            //   return false;
            // case 'interfaceDataFormatCode':
            //   result.message = utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_DATA_FMT'));
            //   return false;
            // case 'interfaceCycleContent':
            //   result.message = utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_CYCL'));
            //   return false;
            // case 'interfaceContent':
            //   result.message = utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_CNTN'));
            //   return false;
            default:
              result.valid = true;
              result.message = '';
          }
        }
        return null;
      });
      return result;
    },
    saveAction(saveData) {
      utils.messageBox('confirm', this.$t('MSG_ALT_WANT_SAVE'), null, () => {
        http.request(this.pageId, 'DTS_CMS_00004', {
          path: {
            'interface-id': this.interfaceId,
          },
          data: saveData,
        }).then(() => {
          utils.messageBox('success', this.$t('MSG_ALT_SAVE_DATA'), null, this.research);
        }).catch(error => {
          console.log(error);
        });
      });
    },
    onDeleteClick() {
      this.$emit('onDelete', [this.interfaceId]);
    },
    research() {
      this.$emit('research');
    },
    onHistoryListClick() {
      this.$emit('onHistoryListClick');
    },
  },
};
</script>
<style scoped>
</style>
